<template>
    <div>
        <div v-if="hasSearch" class="text-center">
            <b-form-input
                v-model="searchTerm"
                type="search"
                placeholder="Meklēt darbiniekus..."
                debounce="100"
                class="my-4 col-sm-3 mx-auto"
                ></b-form-input>
        </div>
        <b-table
            ref="userOvpTable"
            :fields="userFields"
            :items="sortedUsers"
            :filter="searchFilter"
            :filter-included-fields="filterFields"
            :per-page="perPage"
            :current-page="currentPage"
            v-model="visibleRows"
            no-provider-filtering
            no-provider-paging
            :busy="isLoading"
            hover
            small
            responsive
            no-border-collapse
            head-variant="light"
            primary-key="_id"
            selectable
            @context-changed="reSelectRows"
            @row-selected="onRowSelected"
            @filtered="onFiltered"
        >
        <template #table-busy>
            <div class="text-center">
            <b-spinner class="align-middle text-center"></b-spinner>
        </div>
        </template>
        <template #cell(selected)="row">
            <b-form-checkbox :checked="row.rowSelected" @change="(value) => selectByCheckbox(value, row)"></b-form-checkbox>
        </template>
        <template #cell(actions)="{item}">
            <button class="ds-btn" @click.prevent="showApprooveModal(item)" v-if="item.waitingForApprovalOvps.length">Apstiprināt OVP</button>          
        </template>
        <template #row-details="row">
            <UserOvpList :item="row.item" @unselectedOvps="onUnselectedOvps(row.index)"/>
        </template>
    </b-table>
    <b-pagination
        :per-page="20"
        :total-rows="totalRows"
        v-model="currentPage"
        first-number
        last-number
        align="center"
        size="sm"
        ></b-pagination>
        <ApprooveOvp :user="userToApproove"/>
    </div>
</template>
<script>
    import {mapGetters, mapMutations} from 'vuex';

    import * as ovpStoreTypes from '../../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../../vuex/modules/company/company.store-types';
    import UserOvpList from './UserOvpList.vue';
    import ApprooveOvp from './modals/ApprooveOvp.vue';

    export default {
        name: 'user-ovp-job-condition-list-table',
        components: {UserOvpList, ApprooveOvp},
        props: {
            hasSearch: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            searchTerm: '',
            searchTimeout: null,
            healthChechTypeOptions: [{text: 'Pirmreizējā', value: 1}, {text: 'Ārpuskārtas', value: 2}, {text: 'Periodiskā', value: 3, selected: true}],
            currentPage: 1,
            visibleRows: [],
            perPage: 20,
            userToApproove: null,
            selected: new Set(),
            filterFields: ["name", "surname"],
            userFields: [
                {
                    key: "selected",
                    label: "Izvēlēts",
                    thClass: 'col-1',
                },
                {key: "name",
                label: "Vārds Uzvārds",
                thClass: 'text-left col-4 text-break',
                tdClass: 'text-left text-break',
                formatter: (value, key, item) => {
                    return `${item.name} ${item.surname}`
                }        
            },
            {key: "jobTitleIdentifier.name",
                label: "Amats",
                thClass: 'text-left col-3 text-break',
                tdClass: 'text-left text-break',
            },
            {
                key: 'actions',
                label: '',
                thClass: 'text-right col-2',
                tdClass: 'text-right',
            },
            {key: "nextInspectionDate",
                label: "Tuvākās pārbaudes datums",
                thClass: 'text-right col-2',
                tdClass: 'text-right',
                formatter: (value, key, item) => {
                    return item.ovpJobConditions[0].nextInspectionDate
                }
            },
            ]
        }),
        mounted: function () {
            this.$root.$on('opv:user:deselect', (userId) => {
                this.unseLectByUserId(userId)
            })
            this.$root.$on('ovp:user:clearSelection', () => {
                this.clearSelected()
            })
        },

        
        computed: {
            searchFilter() {
                return this.searchTerm ? new RegExp(`${this.searchTerm.split(' ').join('.*')}.*`, "i") : null
            },
            sortedUsers() {
                 const br = [...this.currentCompany.users]
                    .filter(({isOnLongTermLeave}) => !isOnLongTermLeave)
                    .filter(({workExperience}) => workExperience)
                    .filter(({ovpJobConditions}) => ovpJobConditions.length)
                    .sort((a, b) => {
                        // Sorting users by their latest ovp - FYI this needs to be cleaned up!!!
                        const { waitingForApproval: aWaitForApproval, nextInspectionDate: aNextInspectionDate } = a.ovpJobConditions[0];
                        const { waitingForApproval: bWaitForApproval, nextInspectionDate: bNextInspectionDate } = b.ovpJobConditions[0];
                        // This is a workaround for nextInspectionDate, that is null
                        const aDate = aNextInspectionDate ? aNextInspectionDate.split('.') : ['01','01','1970'];
                        const bDate = bNextInspectionDate ? bNextInspectionDate.split('.') : ['01','01','1970'];

                        return bWaitForApproval - aWaitForApproval || new Date(aDate[2], aDate[1], aDate[0]) - new Date(bDate[2], bDate[1], bDate[0]);
                    })
                    .map(user => {
                        user._showDetails = false; 
                        user.waitingForApprovalOvps = user.ovpJobConditions.filter(({waitingForApproval}) => waitingForApproval)
                        user.selectedHeathChechType = 3

                        return user});
                    return br


            },
            totalRows() {
                return this.sortedUsers.length
            },
            ...mapGetters('ovp', {
                /** @type {boolean|*} */
                isLoading: ovpStoreTypes.GET_IS_LOADING,
                /** @type {function|*} */
                selectedUsers: ovpStoreTypes.GET_SELECTED_OVP_USERS,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
                /** @type {boolean|*} */
                isLoading: companyStoreTypes.GET_IS_LOADING,
            }),
        },
        methods: {
            ...mapMutations('ovp', {
                /** @type {function|*} */
                setSelectedUsers: ovpStoreTypes.SET_SELECTED_OVP_USERS,
                /** @type {function|*} */
                unsetSelectedUsers: ovpStoreTypes.UNSET_SELECTED_OVP_USERS,
            }),
            reSelectRows() {
                const selectedIds = Array.from(this.selected).map(({_id}) => _id)
                this.visibleRows.forEach((value, index) => {
                    if (selectedIds.includes(value._id)) {
                        this.$nextTick(function() {
                        this.$refs.userOvpTable.selectRow(index)
                    })                        
                    }
                })
            },
             async onRowSelected(selectedUsersList) {
                const visibleRowIds = this.visibleRows.map(row => row._id)
                const selectedAndVisisble = Array.from(this.selected, (row) => row._id).filter(_id => visibleRowIds.includes(_id))
                const currentSelectedIds = selectedUsersList.map(row => row._id)
                
                if (selectedUsersList.length > selectedAndVisisble.length) {
                    //Always one
                    const newSelected = selectedUsersList.filter(row => !selectedAndVisisble.includes(row._id))[0]
                        newSelected._showDetails = true
                            this.selected.add(newSelected)
                        }
                else {
                    const toRemove = selectedAndVisisble.filter(val => !currentSelectedIds.includes(val))[0]
                    if (!toRemove) return
                    this.unsetSelectedUsers(toRemove)              
                    this.selected = new Set(Array.from(this.selected).filter(sel => {
                        if (toRemove.includes(sel._id) ) {
                            sel._showDetails = false
                        }
                        return toRemove !== sel._id
                        }))
                }    
            },
            onFiltered() {
                this.currentPage = 1    
            },
            selectByCheckbox(value, row) {
                value ? this.$refs.userOvpTable.selectRow(row.index) 
                    : this.$refs.userOvpTable.unselectRow(row.index);
            },
            onUnselectedOvps(rowIndex) {
                this.$refs.userOvpTable.unselectRow(rowIndex)
            },
            unseLectByUserId(userId) {
                const rowToDeselect = this.visibleRows.findIndex((item) => item._id == userId)
                if (rowToDeselect !== -1) {
                    this.$refs.userOvpTable.unselectRow(rowToDeselect)
                } else {
                    this.selected.forEach((item) => {
                        if (item._id == userId) {
                            item._showDetails = false
                            this.selected.delete(item)
                        }
                    })
                    this.unsetSelectedUsers(userId)
                }
            },
            clearSelected() {
                this.selected.clear()
                this.$refs.userOvpTable.clearSelected()
                this.currentPage = 1

            },
            showApprooveModal(user) {
                this.userToApproove = user
                this.$bvModal.show('modal-approove-user-ovp')
            },
        },
    }
</script>